import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import More from "./pages/More";
import EngagementMap from "./pages/Work/EngagementMap";
import GoHam from "./pages/Work/go_ham";
import StandUpReminder from "./pages/Work/stand_up_reminder";
import BookCovers from "./pages/Work/book_cover";
import Layout from "./components/Layout";
import MouseFollower from "mouse-follower";
import gsap from "gsap";

function App() {
    MouseFollower.registerGSAP(gsap);
    const cursor = new MouseFollower();

  return (
      <Layout>
          <Routes>
              <Route exact path="/" element={<Index cursor={cursor} />} />
              <Route exact path="/more" element={<More />} />
              <Route exact path="/work/EngagementMap" element={<EngagementMap cursor={cursor} />} />
              <Route exact path="/work/GO-HAM" element={<GoHam cursor={cursor} />} />
              <Route exact path="/work/Alexa-Stand-Up-Reminder" element={<StandUpReminder cursor={cursor} />} />
              <Route exact path="/work/book-covers" element={<BookCovers cursor={cursor} />} />
          </Routes>
      </Layout>
  );
}

export default App;
